<div class="page">
  <h2>{{ 'mobileSimulator.page.title' | translate }}</h2>

  <div class="phone-wrapper">
    <div class="phone-mockup">
      <app-mobile-app />
    </div>
  </div>
</div>
